/* eslint-disable no-console */
import axios from 'axios';
import Cookies from 'universal-cookie';
import decode from 'jwt-decode';

import Oidc  from 'oidc-client';
import settings from './oidcSettings'

const noop = () => {};
const cookies = new Cookies();

let BASE_URL = 'https://localhost:44359/v1/'  //LOCAL
//let BASE_URL ='https://ddccloudapp.eastus2.cloudapp.azure.com/api/v1/'; //DEV

if (process.env.REACT_APP_ENV === 'qa') {
    BASE_URL ='https://bmqa.ddcanywhere.nyc/api/v1/'; //QA
}

if (process.env.REACT_APP_ENV === 'staging') {
     BASE_URL ='https://benchmarkqa.ddcanywhere.nyc/api/v1/'; //Staging
}

if (process.env.REACT_APP_ENV === 'production') {
  BASE_URL ='https://benchmark.ddcanywhere.nyc/api/v1/'; //PROD
}
//const AUTH_URL = 'https://loalhost:3000/index.html'          //local
//let AUTH_URL = 'https://benchmarkqa.ddcanywhere.nyc/ddcadfs/' //QA
//let AUTH_URL = 'https://ddccloudapp.eastus2.cloudapp.azure.com/ddcadfs/'; //DEV
//let AUTH_URL = 'https://benchmark.ddcanywhere.nyc/ddcadfs/'  //PROD

//BMX LINKS
var INITIATE_TO_URL = 'https://taskordertraining.ddcanywhere.nyc/task-order?projNum=' // INITIATE TO
var INITIATE_STO_URL = 'https://taskordertraining.ddcanywhere.nyc/task-order/' // INITIATE STO
var SITE_SAFETY_URL_PROJECT = 'https://ssstraining.ddcanywhere.nyc/site-safety-plan?projectId=' // SITE SAFETY PROJECTid
var SITE_SAFETY_URL = 'https://ssstraining.ddcanywhere.nyc/site-safety-plan' // SITE SAFETY
var FEP_LITE_URL = 'https://saptraining.ddcanywhere.nyc/ddc/all-agencies' // FEP LITE
var TASK_ORDER_URL = 'https://taskordertraining.ddcanywhere.nyc' // TASK ORDER
var BMX_MY_DASHBOARD_URL = 'https://saptraining.ddcanywhere.nyc/ddc/my-project-dashboard' // BMX MY DASHBOARD
var CHANGE_REQUEST_URL = 'https://changeordertraining.ddcanywhere.nyc/'

if (process.env.REACT_APP_ENV === 'qa') {
    //QA BMX LINKS
    INITIATE_TO_URL = 'https://taskorderqa.ddcanywhere.nyc/task-order?projNum=' // INITIATE TO
    INITIATE_STO_URL = 'https://taskorderqa.ddcanywhere.nyc/task-order/' // INITIATE STO
    FEP_LITE_URL = 'https://sapqa.ddcanywhere.nyc/ddc/all-agencies' // FEP LITE
    TASK_ORDER_URL = 'https://taskorderqa.ddcanywhere.nyc' // TASK ORDER
    BMX_MY_DASHBOARD_URL = 'https://sapqa.ddcanywhere.nyc/ddc/my-project-dashboard'  // BMX MY DASHBOARD
}

if (process.env.REACT_APP_ENV === 'production') {
     //PROD BMX LINKS
     INITIATE_TO_URL = 'https://taskorder.ddcanywhere.nyc/task-order?projNum=' // INITIATE TO
     INITIATE_STO_URL = 'https://taskorder.ddcanywhere.nyc/task-order/' // INITIATE STO
     SITE_SAFETY_URL_PROJECT = 'https://sss.ddcanywhere.nyc/site-safety-plan?projectId=' // SITE SAFETY PROJECTid
     SITE_SAFETY_URL = 'https://sss.ddcanywhere.nyc/site-safety-plan' // SITE SAFETY
     FEP_LITE_URL = 'https://sap.ddcanywhere.nyc/ddc/all-agencies' // FEP LITE
     TASK_ORDER_URL = 'https://taskorder.ddcanywhere.nyc' // TASK ORDER
     BMX_MY_DASHBOARD_URL = 'https://sap.ddcanywhere.nyc/ddc/my-project-dashboard'  // BMX MY DASHBOARD 
     CHANGE_REQUEST_URL = 'https://changeorder.ddcanywhere.nyc/change-order'
} 

// const DOMAIN = window.location.host;
// const CALLBACK_URL = `https://${DOMAIN}/redirect`;
// const LOGIN_URL = `${AUTH_URL}?callback=${CALLBACK_URL}`;
// const LOGOUT_URL = `${AUTH_URL}account/signout`;

const mgr = new Oidc.UserManager(settings);

// Set all cookies on root
function getLocal (name) {
    return cookies.get(name);
}

function setLocal (name, value) {
    const options = {path: '/'};
    if (name === 'refresh_token') {
        let date = new Date();
        date.setTime(date.getTime() + 14 * 86400 * 1000);
        options.expires = date;
    }
    return cookies.set(name, value, options);
}

function removeLocal (name) {
    cookies.remove(name, {path: '/'});
}

function getClaims () {
    return decode(getLocal('access_token'));
}

function logout () {
    const tokens = ['access_code', 'access_token', 'refresh_token', 'user_profile'];
    tokens.forEach(name => removeLocal(name))

    mgr.removeUser();
    mgr.signoutRedirect();
}

const client = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

function redirectToLogin () {

    setLocal('redirect_url', window.location.pathname);
 //window.location.href = LOGIN_URL;
    mgr.signinRedirect();
}

const queue = [];

function handleAuthentication () {

    return new Promise((resolve) => {
        const access_token = getLocal('access_token');
        queue.push(resolve);
        if (queue.length > 1) return;

        if (window.location.hash && window.location.hash!=='') {
            console.log('hash: ' + window.location.hash);
            mgr.signinRedirectCallback()
                 .catch(function (err) {
                     console.log('err');
                     console.log(err);
                     mgr.signinRedirect();
                 })
                 .then(function (user) {
                     console.log('user ');
                     console.log(user);
                     if (user) {
                         const { access_token } = user;
                         setLocal('access_token', access_token);
                         setLocal('user_profile', user.profile);
                     }
                     else {
                         mgr.signinRedirect();
                     }
                     while (queue.length) queue.shift()();

                 });
            console.log(mgr);
        }

        else if (access_token) {
            while (queue.length) queue.shift()();
        } else {
            redirectToLogin();
        }

         

       
    });
}

function withAuth (config, success, failure=noop) {

    return client(config)
    .then(success)
    .catch((error) => {
        if (axios.isCancel(error)) {
            return;
        } else if (error.response && error.response.status === 401) {
            handleAuthentication().then(() => {
                client(config).then(success).catch(failure)
            });

        } else {
            failure(error);
        }
    });
}

function isValid (token) {
    if (!token) return false;
    const currentTime = (new Date()).getTime() / 1000;
   
    return currentTime < decode(token).exp;
}

function withAuthToken (config) {
    const token = getLocal('access_token');
    config.headers['Authorization'] = 'bearer ' + token;
    return config;
}

client.interceptors.request.use(function (config) {

    const token = getLocal('access_token');
    if (isValid(token)) {
        return withAuthToken(config);
    }
    else {
        removeLocal('access_token');
    }

    return handleAuthentication()
        .then(() => withAuthToken(config));

}, function (error) {
    return Promise.reject(error);
});

function getNameFromToken() {
  // const token = getLocal('access_token');
  // if (isValid(token)) {
  //   const decoded = decode(token);

  //   if (decoded.commonname === "QA Tester")
  //     return `${decoded.winaccountname}`;
  //   else

  //     return `${decoded.given_name} ${decoded.family_name}`;
  // }
  // return '';
    var usrProfile = getLocal('user_profile');
    if (usrProfile != null) {
    //console.log(usrProfile);
        return usrProfile.name;
    }
    return '';
}

function getEmailFromToken() {
    var usrProfile = getLocal('user_profile');
    if (usrProfile != null) {
    //console.log(usrProfile);
        return usrProfile.email;
    }
    return '';
}

export {
  setLocal,
  getLocal,
  getClaims,
  logout,
  client,
  BASE_URL,
 // AUTH_URL,
 // LOGIN_URL,
  withAuth,
  getNameFromToken,
  getEmailFromToken,

INITIATE_TO_URL,
INITIATE_STO_URL,
SITE_SAFETY_URL_PROJECT,
SITE_SAFETY_URL,
FEP_LITE_URL,
TASK_ORDER_URL,
BMX_MY_DASHBOARD_URL,
CHANGE_REQUEST_URL
}